



























































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Getter } from 'vuex-class';
import { format } from 'date-fns';
import { AdminRoleList } from '@/configs/role';
import { getSmsLogList, postSendSms } from '@/configs/api-path';
import CheckProjectMixin from '@/mixins/check-project';
import VuetableMixin from '@/mixins/vuetable';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import ProgressSmsAlertMixin from '@/mixins/progress-sms';
import DatatableHeading from '@/components/piaf/Datatable/DatatableHeading.vue';
import VuetablePaginationBootstrap from '@/components/piaf/Common/VuetablePaginationBootstrap.vue';
import { VuetableSortOrder, VuetablePagination } from '@/@types/vuetable.d';
import { roleIsHigherThen } from '@/utils/role';
import { ProjectMenu, AttachProject } from '@/models/project';
import { SmsLogsListItem } from '@/models/progress';
import { UserLogin } from '@/models/user';

const REFRESH_SECONDS = 300;

const extendSmsErrorMessage = {
  110: '簡訊帳號餘額不足，無法使用簡訊發送服務，請至三竹簡訊購買儲值點數',
  111: '沒有簡訊需要發送',
  4: '簡訊發送失敗，進度狀態未啟用或是簡訊內容未填寫',
};

@Component({
  components: {
    DatatableHeading,
    VuetablePaginationBootstrap,
  },
})
export default class PageProgressSmsLog extends mixins(
  CheckProjectMixin, VuetableMixin, ApiStatusMixin, ApiErrorMixin, ProgressSmsAlertMixin,
) {
  tablePrepage = 10;

  currentProject: AttachProject | null = null;

  currentProgress: {
    id: number;
    title: string;
  } | null = null;

  project: ProjectMenu | null = null;

  lastedUpdate: number | null = null;

  smsList: SmsLogsListItem[] = [];

  dataTableFields = [
    {
      name: 'name',
      title: '住戶姓名',
      sortField: 'name',
    },
    {
      name: 'mobile',
      title: '住戶手機',
      sortField: 'mobile',
    },
    {
      name: 'delivery_time',
      title: '發送日期',
      sortField: 'delivery_time',
      formatter(value: string | null) {
        return value || '--';
      },
    },
    {
      name: 'delivery_status--slot',
      title: '發送狀態',
      width: '140px',
      sortField: 'delivery_status',
    },
    {
      name: 'sms_count',
      title: '發送次數',
      width: '80px',
      sortField: 'sms_count',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: 'action--slot',
      title: '操作',
      width: '150px',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refreshTimer: any = null;

  refreshCountDown: number = REFRESH_SECONDS;

  autoRefresh = true;

  get projectId() {
    return this.$route.params.projectId;
  }

  get progressId() {
    return this.$route.params.progressId;
  }

  get filtedProgressList() {
    return this.smsList
      .filter((smsLog) => {
        const matchRegexp = new RegExp(this.filterKeyword === '' ? '.*' : `.*(${this.filterKeyword}).*`, 'gi');

        const matchSmsLogName = smsLog.name === '' ? true : smsLog.name.match(matchRegexp);
        const matchSmsLogMobile = smsLog.mobile === '' ? true : smsLog.mobile.match(matchRegexp);

        return Boolean(matchSmsLogName) || Boolean(matchSmsLogMobile);
      });
  }

  get lastedUpdateString() {
    return this.lastedUpdate ? format(this.lastedUpdate, 'yyyy/MM/dd HH:mm:ss') : '--';
  }

  get refreshCountDownString() {
    // return format(parse(this.refreshCountDown.toString(), 'ss', 0), 'mm:ss');
    return this.refreshCountDown;
  }

  get breadcrumb() {
    return [
      {
        text: '進度管理',
        to: null,
      },
      {
        text: this.currentProject?.name,
        to: null,
      },
      {
        text: this.currentProgress?.title,
        to: null,
      },
      // {
      //   text: '簡訊狀態列表',
      //   to: null,
      // },
    ];
  }

  @Getter('user/currentUser') currentUser!: UserLogin;

  @Watch('filtedProgressList')
  onFiltedProgressListChange() {
    this.$refs.vuetable.refresh();
  }

  @Watch('autoRefresh')
  onAutoRefreshChanged(val: boolean) {
    if (val === true) {
      if (this.refreshTimer === null) {
        this.initTimer();
      }
    } else if (val === false) {
      if (this.refreshTimer !== null) {
        this.destroyTimer();
      }
    }
  }

  @Watch('tablePrepage')
  onTablePrepageChange() {
    if (this.vuetablePrepage !== undefined) {
      this.vuetablePrepage = this.tablePrepage;
    }
    this.$refs.vuetable.refresh();
  }

  // eslint-disable-next-line class-methods-use-this
  mapDeliveryStatus(deliveryStatus: number) {
    let label = 'N/A';

    switch (deliveryStatus) {
      case 0:
        label = '未發送';
        break;

      case 1:
        label = '已發送';
        break;

      case 2:
        label = '發送失敗';
        break;

      default:
        break;
    }

    return label;
  }

  testRoleIsHigher(roleCode: number) {
    return roleIsHigherThen((this.currentUser.role as AdminRoleList).code, roleCode, true);
  }

  changePageSize(size: number) {
    this.tablePrepage = size;
  }

  onChangePage(page: number) {
    this.$refs.vuetable.changePage(page);
  }

  dataManager(sortOrder: VuetableSortOrder[], pagination: VuetablePagination) {
    const tableData = this.vuetableDataManager(
      sortOrder,
      pagination,
      this.$refs.vuetable,
      this.filtedProgressList,
    );
    this.tablePagination = tableData.pagination;
    return tableData;
  }

  onPaginationData(paginationData: VuetablePagination) {
    this.$refs.pagination.setPaginationData(paginationData);
  }

  async sendSms(userId?: number) {
    if (!this.progressId) {
      return;
    }

    try {
      const sendData: {
        progressId: number;
        userId?: number;
      } = {
        progressId: parseInt(this.progressId, 10),
      };

      if (userId !== undefined) {
        sendData.userId = userId;
      }

      const { data: smsResponse } = await this.$axios.post<{
        code: number;
      }>(postSendSms, sendData);

      if (smsResponse.code === 0) {
        this.smsAlertAfterSent();
        this.fetchSmsList();
      } else {
        this.apiErrorCodeAlert(smsResponse.code, '建案進度管理', extendSmsErrorMessage);
      }
    } catch (err) {
      console.error(err);
    }
  }

  sendGroupSms(check: boolean) {
    if (check === true) {
      this.sendSms();
    }
  }

  sendSingleSms(check: boolean, userId: number) {
    if (check === true) {
      this.sendSms(userId);
    }
  }

  cancelSendSms() {
    this.$notify.show('info filled', '簡訊未發送', '建案進度管理');
  }

  /* Refresh timer */
  initTimer() {
    this.refreshTimer = setInterval(() => {
      if (this.refreshCountDown === 0) {
        this.refreshCountDown = REFRESH_SECONDS;
      }

      this.refreshCountDown -= 1;

      if (this.refreshCountDown === 0) {
        this.destroyTimer();
        this.autoRefreshSmsList();
      }
    }, 1000);
  }

  destroyTimer() {
    clearInterval(this.refreshTimer);
    this.refreshCountDown = REFRESH_SECONDS;
    this.refreshTimer = null;
  }

  async autoRefreshSmsList() {
    if (!this.autoRefresh) {
      return;
    }

    if (!this.progressId) {
      return;
    }

    try {
      const { data: progressListResponse } = await this.$axios.get<{
        code: number;
        user: SmsLogsListItem[];
      }>(getSmsLogList(this.progressId));

      if (progressListResponse.code === 0) {
        this.smsList = progressListResponse.user;
        this.lastedUpdate = new Date().getTime();

        if (this.autoRefresh === true) {
          this.initTimer();
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  async fetchSmsList() {
    if (!this.progressId) {
      this.$notify.show('error filled', '查無此進度', '建案進度簡訊管理');
      return;
    }

    this.setApiLoading();
    try {
      const { data: progressListResponse } = await this.$axios.get<{
        code: number;
        user: SmsLogsListItem[];
      }>(getSmsLogList(this.progressId));

      if (progressListResponse.code === 0) {
        this.smsList = progressListResponse.user;
        this.lastedUpdate = new Date().getTime();
        if (this.refreshTimer === null) {
          this.initTimer();
        }
      } else {
        this.apiErrorCodeAlert(progressListResponse.code, `${this.currentProgress?.title}進度管理`);
      }
    } catch (error) {
      console.error(error);
      this.apiHttpErrorAlert(error.response, `${this.currentProgress?.title}進度管理`);
    }
    this.setApiPending();
  }

  async checkProjectAndFetch() {
    try {
      this.setApiLoading();
      const projectExist = await this.checkProjectExistII(this.projectId);
      const progressExist = await this.checkProgressExist(this.progressId);
      this.setApiPending();

      if (projectExist.code === 0 && progressExist.code === 0) {
        this.currentProject = {
          id: projectExist.project.id,
          name: projectExist.project.name,
        };

        this.currentProgress = {
          id: progressExist.progress.id,
          title: progressExist.progress.title,
        };

        this.fetchSmsList();
      }
      if (projectExist.code !== 0) {
        this.$notify.show('error filled', projectExist.message, '建案進度簡訊管理');
      }
      if (progressExist.code !== 0) {
        this.$notify.show('error filled', progressExist.message, '建案進度簡訊管理');
      }
    } catch (error) {
      this.$notify.show('error filled', error.message, '建案進度簡訊管理');
      console.error(error.message);
    }
  }

  beforeMount() {
    this.checkProjectAndFetch();
  }

  beforeDestroy() {
    if (this.refreshTimer !== null) {
      this.destroyTimer();
    }
  }
}
